// extracted by mini-css-extract-plugin
module.exports = {"routeHeader":"vehicle-reports_routeHeader_2eDpw","addButton":"vehicle-reports_addButton_1IV0n"};